function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 705",
    transform: "translate(-650 -35)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 27",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(650 35)",
    style: {
      fill: "#4fb589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (2)",
    d: "m12 6-5.5 5.5L4 9",
    transform: "translate(652.5 36.5)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.a81333bae712c3b83fc6b6997b5c2459.svg";
export { ForwardRef as ReactComponent };